import { MultiCountrySurvey } from '../interface/multi-country.interface';

export class MultiCoutrySurveyTitleExtractor {
  constructor(private _survey: MultiCountrySurvey) {}

  public extract(): string {
    const defaultIdentifierRegex = new RegExp(
      ` - MC-${this._survey.country_code}-${this._survey.language_code}`,
      'g'
    );

    const countryCodeRegex = new RegExp(`^${this._survey.country_code}$`, 'g');

    const languageCodeRegex = new RegExp(
      `^${this._survey.language_code}$`,
      'g'
    );
    return this._survey.survey_title
      .replace(defaultIdentifierRegex, '')
      .replace(countryCodeRegex, '')
      .replace(languageCodeRegex, '');
  }
}
